import rstours from './rstours/EmailBody';

export default function (organisationId = 1, body = '', phone = '', email = null, locale = 'de_DE') {
    return rstours(body, phone, email, locale);
}
